export const ROUTE_IDS = {
  ownership: '#ownership',
  businessDetails: '#businessDetails',
  businessAddress: '#businessAddress',
  officeAddress: '#officeAddress',
  businessDocuments: '#businessDocuments',
  bankDetails: '#bankDetails',
  stores: '#stores',
  agents: '#agents',
  review: '#review',
} as const;

export type RouteKey = keyof typeof ROUTE_IDS;
export type RouteId = (typeof ROUTE_IDS)[keyof typeof ROUTE_IDS];
